import { render, staticRenderFns } from "./MyOrderDetails.vue?vue&type=template&id=f3a8d0f8&scoped=true"
import script from "./MyOrderDetails.vue?vue&type=script&lang=js"
export * from "./MyOrderDetails.vue?vue&type=script&lang=js"
import style0 from "./MyOrderDetails.vue?vue&type=style&index=0&id=f3a8d0f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3a8d0f8",
  null
  
)

export default component.exports